import { Injectable } from '@angular/core';
import { SharedService } from "./shared.service";

@Injectable()
export class OpsService {

  constructor(private _sharedService: SharedService) { }



  public GetOpsListByRefIdForSpra(RefId:number){
    let Data:any = {
      "refId" :RefId
    }
    return this._sharedService.Get("Ops/GetOpsListByRefIdForSpra",Data);      
  }

  public GetOpsDetailByOpsId(opsId:number){
    let Data:any = {
        "opsId" :opsId
      } 
    return this._sharedService.Get("Ops/GetOpsDetailByOpsId",Data);      
  }

  
}
